<div class="dashboard-main gap-0 h-100vh">
  <mat-accordion>
    <mat-expansion-panel class="plan-expansion workbook-top-expansion" expanded="true">
      <mat-expansion-panel-header class="d-block d-lg-none about-eng-header">
        <mat-panel-title>
          <div class="plan-expansion-header">
            <button mat-button mat-stroked-button color="dark" class="button-default">
              <span class="flexbox-row gap-8 flex-nowrap">
                <span class="title">Detail</span>
                <span class="toggle-icon dot-16 bg-transparent"></span>
              </span>
            </button>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="plan-expansion-body">
        <header
          class="d-flex flex-wrap flex-column flex-lg-row align-items-lg-center justify-content-between gap-8 bg-primary p-3">
          <div class="header-left d-flex flex-column flex-lg-row flex-wrap align-items-lg-center gap-8">
            <div class="flexbox-row gap-8 w-auto align-self-start">
              <ngx-avatars initialsSize="1" size="22" bgColor="#ffffff" fgColor="#3373a5"
                [name]="selectedEngagementDataCopy.engagementtype" [round]="false" textSizeRatio="1.4"></ngx-avatars>
              <h6 class="title text-white" title="{{selectedEngagementDataCopy.engagementtype}}"
                *ngIf="selectedEngagementDataCopy.pengagementtypeid != 1">
                {{selectedEngagementDataCopy.engagementtype}}
              </h6>
              <h6 class="title text-white" title="COM" *ngIf="selectedEngagementDataCopy.pengagementtypeid == 1">COM
              </h6>
            </div>
            <p class="text-white">Engagement Name: <b>{{engagementName}}</b></p>
          </div>

                    <div class="header-middle">
                        <p class="text-white">Client Name: <b>{{ clientName }}</b></p>
                    </div>

                    <div class="header-right">
                        <p class="text-white">Year End Date: <b>{{ yearEnd| appCountableTimeZone:'MMM d, y':'UTC' }}</b>
                        </p>
                    </div>
                </header>
            </div>
        </mat-expansion-panel>
    </mat-accordion>

    <!-- h-100 overflow-hidden -->
    <div class="leadsheet-section-content h-100 overflow-hidden"
         [ngClass]="[isSideMenuExpanded ? 'left-side-menu-enabled' : 'left-side-menu-desabled', isPreviewPanelExpanded ? 'prview-panel-enabled' : 'prview-panel-desabled']">

        <!-- h-100 overflow-hidden -->
        <mat-drawer-container class="countable-drawer-new w-100">
            <mat-drawer #drawer opened appResizableDrawer [minWidth]="300" [maxWidth]="500"
                        (resizeEvent)="onResizePanelEnd($event)" style="width:300px;">
                <div #leftPanel class="template-block-main content-block">
                    <mat-list role="list" class="templates-list-items" cdkDropList (cdkDropListDropped)="drop($event)">
                        <mat-list-item role="listitem" *ngFor="let menuData of workBookLeftSideMenu">
                            <div class="list-item-content" routerLinkActive="active"
                                 [ngClass]="{'active': router.url == menuData.routeUrl || (router.url).split('?')[0] == menuData.routeUrl}"
                                 cdkDrag
                                 [cdkDragDisabled]="shortCutMenuDetails.isenglock != 0 || !acl?.hasEngViewEdit || isEditableMenu">
                                <ng-container
                                        *ngIf="isEditableMenu && subModuleId === menuData.submoduleid; else isEditable">
                                    <mat-form-field
                                            class="fixed-label icon-form-after action-2 w-100 form-field-medium">
                                        <input matInput type="text" value="{{menuData.submodulename}}" maxlength="60"
                                               [(ngModel)]="menuData.submodulename">
                                        <div matSuffix class="actions border-start">
                                            <button mat-button color="success" (click)="saveLeftSideMenuName(menuData)"
                                                    [disabled]="!acl?.hasEngViewEdit">
                                                <i class="fa-regular fa-check"></i>
                                            </button>
                                            <button mat-button color="cancel"
                                                    (click)="isEditableMenu = false; menuData.submodulename = isOldSubModuleName">
                                                <i class="fa-regular fa-xmark clear-icon"></i>
                                            </button>
                                        </div>
                                    </mat-form-field>
                                </ng-container>

                                <ng-template #isEditable>
                                    <span class="dragable-icon" *ngIf="shortCutMenuDetails.isenglock == 0" [ngClass]="{'disabled': !acl?.hasEngViewEdit}"  >
                                        <i class="fa-solid fa-grip-dots-vertical"></i>
                                    </span>
                                    <span class="item-title lable label-title" [id]="menuData?.submoduleid+'_workbookMenu'"
                                          [ngClass]="{'cash-flow-title' : menuData.uirouting === 'cashflow' , 'notes-title' : menuData.uirouting === 'notestofs' , 'income-title' : menuData.uirouting === 'incomeloss' , 'retained-title' : menuData.uirouting === 'retainedearning', 'income-retained-title' : menuData.uirouting === 'incomeandretained'}"
                                          title="{{menuData.submodulename}}" (click)="viewPage(menuData)">
                                        {{ menuData.submodulename }}
                                    </span>
                                    <ng-container *ngIf="acl?.hasEngViewEdit">
                                        <button mat-button class="edit-icon button-medium-icon"
                                                *ngIf="shortCutMenuDetails.isenglock == 0"
                                                (click)="isMenuEditable(menuData);  isOldSubModuleName = menuData.submodulename">
                                            <i class="fa-regular fa-pen fs-15"></i>
                                        </button>
                                    </ng-container>
                                </ng-template>
                            </div>
                        </mat-list-item>
                    </mat-list>
                    @if (leftSideMenuSchedules && workBookLeftSideMenu?.length) {
                        <mat-accordion multi="true" cdkDropList (cdkDropListDropped)="onDrop($event)">
                            <mat-expansion-panel [expanded]="isExpandSchedule()">
                                <mat-expansion-panel-header>
                                    <mat-panel-title>
                                        <div class="title-content child-level-signoff border-b-none">
                                            <span class="togglable-icon">
                                                @if (leftSideMenuSchedules?.schedules?.length) {
                                                    <i class="toogle-icon fa-solid fa-angle-right fs-3"></i>
                                                }
                                            </span>
                                                <span class="item-title fw-medium" title="{{ leftSideMenuSchedules?.name }}">
                                                {{ leftSideMenuSchedules?.name }}
                                            </span>
                                                <button mat-button [disabled]="isSyncCall()" (click)="createSchedule($event)" class="button-text" title="Create Schedule">
                                                    <i class="fa-solid fa-plus text-primary-dark-new"></i>
                                                </button>
                                        </div>
                                    </mat-panel-title>
                                </mat-expansion-panel-header>
                                @for (schedule of leftSideMenuSchedules.schedules; track schedule.id; let i = $index) {
                                    <mat-expansion-panel class="level-one" hideToggle>
                                        <mat-expansion-panel-header cdkDrag [cdkDragDisabled]="isSyncCall()" class="schedule-panel">
                                            <mat-panel-title>
                                                <div class="title-content child-level-signoff border-b-none" cdkDragHandle>
                                                        <span class="dragable-icon"><i
                                                                class="fa-solid fa-grip-dots-vertical"></i></span>
                                                        <span class="item-title fw-medium" (click)="saveChangesSchedule(schedule)" title=" {{ 'Schedule ' + schedule.sortOrder }} - {{schedule?.nameChange ? schedule?.nameChange : schedule.name }}">
                                                        {{ 'Schedule ' + schedule.sortOrder }} - {{schedule?.nameChange ? schedule?.nameChange : schedule.name }}
                                                        </span>

                                                    @if (isSyncCall() && schedule.uuid === selectedSchedule()) {
                                                        <span class="smooth-gradient-ring-s"></span>
                                                    } @else {
                                                        <button mat-button class="kebab-button" [disabled]="isSyncCall()"
                                                                [matMenuTriggerFor]="matRowKebabMenu"
                                                                [matMenuTriggerData]="{row: schedule}">
                                                            <i class="fas fa-ellipsis-vertical"></i>
                                                        </button>
                                                    }

                                                </div>
                                            </mat-panel-title>
                                        </mat-expansion-panel-header>
                                    </mat-expansion-panel>
                                }


                            </mat-expansion-panel>
                        </mat-accordion>
                    }
                </div>
            </mat-drawer>

            <mat-drawer-content class="overflow-hidden h-100">
                <div #togglePanel class="toogle-button-block button-block-left">
                    <button mat-button class="button-medium-icon toogle-button" (click)="drawer.toggle()"></button>
                    <div class="toogle-content">
                        <h6 class="title">Workbook</h6>
                    </div>
                </div>
                <div #centerSection class="contant-block-main w-100 h-100 overflow-hidden"
                     [ngClass]="{'tbl-ins-enabled': (router.url =='/trial-balance-working-sheet/income-statement') ||
        (router.url =='/trial-balance-working-sheet/balance-sheet') || (router.url =='/trial-balance-working-sheet/retained-earnings')|| (router.url =='/trial-balance-working-sheet/cf-work-sheet') || (router.url =='/trial-balance-working-sheet/partners-capital')|| (router.url =='/trial-balance-working-sheet/cashflow')|| (router.url =='/trial-balance-working-sheet/fs-notes')}">
                    <router-outlet></router-outlet>
                </div>
            </mat-drawer-content>
        </mat-drawer-container>
    </div>
</div>


<!--schedules kebab options delete-->
<mat-menu #matRowKebabMenu="matMenu">
    <ng-template matMenuContent let-aliasMenuItems="row">
        <button mat-menu-item (click)="deleteSchedule(aliasMenuItems)"><i class="fa-regular fa-trash-can"></i> Delete
        </button>
    </ng-template>
</mat-menu>
